import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import api from '../services/api';

export default function Produtos() {
  const [produto, setProduto] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/produtos').then(({ data }) => setProduto(data[0])).finally(() => setLoading(false));
  }, []);

  if (loading) return <><Navbar /><p className="carregando">Carregando…</p></>;

  const bens = typeof produto?.beneficios === 'string' ? JSON.parse(produto.beneficios) : produto?.beneficios || [];
  const msgWA = encodeURIComponent(produto?.mensagem_whatsapp || 'Olá, tenho interesse no selante automotivo Heritage.');
  const linkWA = `https://wa.me/55${produto?.whatsapp_contato?.replace(/\D/g,'')}?text=${msgWA}`;

  return (
    <>
      <Navbar />
      <div style={{ background: 'var(--cream)', minHeight: 'calc(100vh - 112px)' }}>

        {/* Hero produto */}
        <div style={{ background: 'linear-gradient(135deg, var(--ink) 0%, #2a1a0e 100%)', padding: '72px 0' }}>
          <div className="container">
            <div className="produto-hero-grid">
              <div>
                <div style={{ color: 'var(--rust)', fontSize: 11, letterSpacing: 2.4, textTransform: 'uppercase', fontWeight: 900, marginBottom: 14 }}>Produto Heritage</div>
                <h1 style={{ fontFamily: "'Playfair Display',serif", fontSize: 46, color: '#fff', fontWeight: 600, lineHeight: 1.05, marginBottom: 16 }}>
                  {produto?.nome || 'Selante Automotivo Heritage'}
                </h1>
                <p style={{ color: 'rgba(255,255,255,.65)', fontSize: 16, lineHeight: 1.75, marginBottom: 10, fontStyle: 'italic' }}>
                  {produto?.chamada_comercial}
                </p>
                <p style={{ color: 'rgba(255,255,255,.55)', fontSize: 14, lineHeight: 1.7, marginBottom: 32 }}>{produto?.descricao}</p>
                {produto?.preco && produto?.preco_exibir ? (
                  <div style={{ fontSize: 32, fontWeight: 900, color: 'var(--gold)', marginBottom: 24 }}>
                    R$ {Number(produto.preco).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                  </div>
                ) : (
                  <p style={{ fontSize: 13, color: 'rgba(255,255,255,.45)', marginBottom: 24 }}>Consulte disponibilidade e condições.</p>
                )}
                <a href={linkWA} target="_blank" rel="noopener noreferrer" className="btn btn-gold">
                  💬 Comprar pelo WhatsApp
                </a>
              </div>
              <div style={{ background: 'rgba(255,255,255,.04)', border: '1px solid rgba(216,189,105,.2)', borderRadius: 'var(--r-lg)', height: 360, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 80 }}>
                💧
              </div>
            </div>
          </div>
        </div>

        {/* Benefícios */}
        {bens.length > 0 && (
          <div style={{ background: 'var(--cream-dark)', padding: '72px 0' }}>
            <div className="container">
              <div style={{ textAlign: 'center', marginBottom: 44 }}>
                <div className="eyebrow">Benefícios</div>
                <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 32, fontWeight: 600 }}>Por que usar o Selante Heritage?</h2>
              </div>
              <div className="produto-bens-grid">
                {bens.map((b, i) => (
                  <div key={i} className="card" style={{ padding: '22px 24px', display: 'flex', gap: 14 }}>
                    <span style={{ color: 'var(--rust)', fontSize: 18, flexShrink: 0 }}>✦</span>
                    <p style={{ fontSize: 14, lineHeight: 1.65, color: 'var(--ink-mid)' }}>{b}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Para quem */}
        <div style={{ background: 'var(--cream)', padding: '64px 0' }}>
          <div className="container" style={{ maxWidth: 860 }}>
            <div style={{ background: 'var(--ink)', borderRadius: 'var(--r-lg)', padding: '48px 52px', textAlign: 'center' }}>
              <div style={{ color: 'var(--rust)', fontSize: 11, letterSpacing: 2.4, textTransform: 'uppercase', fontWeight: 900, marginBottom: 14 }}>Indicado para</div>
              <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 28, color: '#fff', fontWeight: 600, marginBottom: 28 }}>Para quem é o Selante Heritage?</h2>
              <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
                {['Proprietários de clássicos', 'Colecionadores', 'Entusiastas', 'Donos de veículos de uso diário'].map(t => (
                  <div key={t} style={{ background: 'rgba(216,189,105,.12)', border: '1px solid rgba(216,189,105,.25)', borderRadius: 'var(--r-sm)', padding: '8px 18px', color: 'var(--gold)', fontSize: 13, fontWeight: 700 }}>{t}</div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Novos produtos */}
        <div style={{ background: 'var(--cream-dark)', padding: '40px 0 64px' }}>
          <div className="container" style={{ maxWidth: 600, textAlign: 'center' }}>
            <div className="eyebrow">Em breve</div>
            <h3 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, marginBottom: 10 }}>Novos produtos Heritage</h3>
            <p style={{ color: 'var(--ink-muted)', fontSize: 14, lineHeight: 1.65 }}>
              A Heritage está desenvolvendo novos produtos para cuidado, proteção e conservação automotiva.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
